import { environments } from 'src/siteConfig';
import type { Environment } from 'src/types';

export default ({ environment }: { environment: Environment }) => ({
  features: {
    allowAdministrationOfLinkedPayment:
      environment === environments.development,
  },
});
